import { style } from '@do/walrus';
import React, { ReactElement } from 'react';
import styled from 'styled-components';
import vars from '../assets/overwrite-vars';
import { Err, ErrorBanner as CommonErrorBanner } from './Common';

const ErrorBannerWrapper = styled.div`
  div:first-child {
    border: ${style.vars.borderWidth.thin} solid ${vars.red_darkest};
    background-color: ${vars.red_lightest};
    box-sizing: border-box;
    border-radius: ${vars.border_radius_xlarge};
    padding: ${style.vars.whitespace.regular};

    & svg {
      margin-top: 0 !important;
      margin-right: ${style.vars.whitespace.small} !important;
      width: 32px;
      height: 32px;
    }

    & small {
      color: ${vars.grey2};
      font-size: ${vars.font_size_medium};
      font-weight: normal;
    }

    .do-u-textSmall {
      font-size: 1rem !important;
      color: ${vars.dark};
    }
  }
`;

const ErrorBanner = (props: Err): ReactElement => {
  return (
    <ErrorBannerWrapper>
      <CommonErrorBanner {...props} />
    </ErrorBannerWrapper>
  );
};

export default ErrorBanner;
